export function hideLastProductIfOnlyOneInRow() {
    var promoExists = false;
    if (phe.config.isSiteRedesign2022 && document.querySelector('.ae-plp[data-cy="product-grid"] .offer-space[data-cy="product-grid-item"]')) {
        promoExists = true;
    } else if (document.querySelector('#items .c-product-results-items .offer-space.c-grid-item') || document.querySelector('.ae-plp[data-cy="product-grid"] .module-plpadspace')) {
        promoExists = true
    }

    if (promoExists) { // if promo spot exists
        var products = document.querySelectorAll('#items .c-product-results-items .c-grid-item, [data-cy="product-grid-item"]');
        [].slice.call(products).map(function (element) {
            element.classList.remove('hidden');
        });

        var hideLastItems = 0;
        if (document.querySelectorAll('.ae-plp[data-cy="product-grid"] .module-plpadspace')) {
            var cnt = 0;
            Array.from(document.querySelectorAll('.ae-plp[data-cy="product-grid"] .module-plpadspace')).map(function (ele) {
                cnt += parseInt(ele.dataset.rowSpan) * (window.matchMedia('(min-width:1008px)').matches ? Math.min(parseInt(ele.dataset.columnSpan), 4) : window.matchMedia('(min-width:768px)').matches ? Math.min(parseInt(ele.dataset.columnSpan), 3) : Math.min(parseInt(ele.dataset.columnSpan), 2));
            });
            cnt = (parseInt(products[products.length - 1].dataset.itemIndex) + 1) + cnt;
            if (window.matchMedia('(min-width:1008px)').matches) {  //desktop 4x1
                hideLastItems = cnt % 4;
            } else if (window.matchMedia('(min-width:768px)').matches) { //tablet view 3x1
                hideLastItems = cnt % 3;
            }
            else { //Mobile view 2x1
                hideLastItems = cnt % 2;
            }
        }
        var current_load_more_button = document.getElementById('load-more-component'); //check if load more exist then hide last item due to Promo spot
        if (current_load_more_button
            && !current_load_more_button.classList.contains('hidden')
            && products
            && products.length > 0
            && hideLastItems > 0) {
            for (var i = hideLastItems; i > 0; i--) {
                products[products.length - i].classList.add('hidden')
            }
        }
    }
}
